import {Component} from "@angular/core";
import {MenuExtraGroupData, MenuItemData} from "../../../../menu/menu-entity.model";
import {Page} from "../../../../orchestration/page";
import {NavigationService} from "../../../../orchestration/navigation.service";
import {ButtonProminence} from "../../../../buttons/button/button";
import {NavigationParams} from "../../../../orchestration/navigation-params";

import {OrderItem} from "../../../order";

@Component({
    selector: "woa-order-item-combined-extras-edit-page",
    templateUrl: "./order-item-combined-extras-edit-page.component.html",
    providers: [{provide: Page, useExisting: OrderItemCombinedExtrasEditPageComponent}]
})
export class OrderItemCombinedExtrasEditPageComponent extends Page {
    ButtonProminence = ButtonProminence;

    orderItem: OrderItem;
    mainOrderItem: OrderItem;
    originalOrderItem: OrderItem;
    menuItem: MenuItemData;
    promotedExtraGroup: MenuExtraGroupData;

    changesMade: boolean = false;

    constructor(navigationParams: NavigationParams,
                public navigationService: NavigationService) {
        super();
        this.orderItem = navigationParams.get("orderItem");
        this.mainOrderItem = navigationParams.get("mainOrderItem");
        this.originalOrderItem = navigationParams.get("originalOrderItem");
        this.menuItem = navigationParams.get("menuItem");
        this.promotedExtraGroup = navigationParams.get("promotedExtraGroup");
    }

    get title(): string {
        return this.promotedExtraGroup ? ("'" + (this.promotedExtraGroup.externalName || this.promotedExtraGroup.name) + "'") : "woa.heading.order.multiSelectExtrasEdit";
    }
}



// WEBPACK FOOTER //
// ./src/app/order/order-item/order-item-options-panel/order-item-combined-extras-edit-page/order-item-combined-extras-edit-page.component.ts